import base from '../../base';
import { CUSTOMER } from '../../../constraints';

const config = {
  ...base,
  backendUrl: 'https://apimvppublication.tdm.bybillon.com',
  enablePrivate: true,
  customer: CUSTOMER.DEFAULT,
  language: 'pl',
  manageRecipients: true,
};

export default config;
